import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLogoWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={41} height={40} fill='none' {...props}>
    <g fill='#fff' clipPath='url(#logo-white_svg__a)'>
      <path d='M40.5 19.982h-7.952c-.007-6.646-5.405-12.03-12.051-12.03-1.694 0-3.303.346-4.756.98-1.94.833-3.62 2.16-4.869 3.825a12 12 0 0 0-2.42 7.225v.021c0 6.654 5.39 12.045 12.045 12.045 1.686 0 3.288-.346 4.741-.967l3.14 7.31a19.95 19.95 0 0 1-7.881 1.616C9.454 40 .5 31.046.5 20.004v-.022A19.93 19.93 0 0 1 4.515 7.973a20.03 20.03 0 0 1 8.086-6.35A19.9 19.9 0 0 1 20.497 0C31.539 0 40.493 8.947 40.5 19.982' />
      <path d='M32.548 19.982v.022c0 4.967-3.013 9.236-7.303 11.077l-4.763-11.099z' />
    </g>
    <defs>
      <clipPath id='logo-white_svg__a'>
        <path fill='#fff' d='M.5 0h40v40H.5z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoWhite;
